// extracted by mini-css-extract-plugin
export default {"container":"MyPageScreen_container__ohDQc","info":"MyPageScreen_info__FIecj","select":"MyPageScreen_select__NOJYU"};